<template>
  <form class="t-callBack" @submit.stop.prevent="Submit()">
    <h2> {{ renameDialog.title }} </h2>
    <div class="t-input" v-for="(item, index) in form" :key="index" :class="{_error: item.error}">
        <label>{{ item.label }}</label>
        <input v-model="item.value" :type="item.type" :placeholder="item.placeholder" @focus="Focus(index)">
    </div>
    <button class="t-btn"><span> {{ renameDialog.btn }} </span></button>
  </form>
</template>

<script>
    import {store} from '../../store'

    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';

    export default {
        data(){
            return{
                action: 'dialog/edit',
                form: [
                    {
                        label: store.getters['staticText/renameDialog'].inputTitle_1,
                        name: 'name',
                        type: 'input',
                        value: '',
                        placeholder: '',
                        error: false,
                        pattern: /.+/
                    }
                ],
            }
        },
        props: ['props'],
        computed: {
            ...mapGetters(['mobile']),
            ...mapGetters('staticText', ['renameDialog']),
        },
        methods: {
            ...mapActions('modal', ['modalDialogClose']),
            ...mapActions('msg', ['showMsg']),
            Submit(){
                let is_valid = true;

                for(let i = 0; i < this.form.length; i++){
                    if(this.form[i].pattern !== '') {
                        if (!this.form[i].pattern.test(this.form[i].value)) {
                            this.form[i].error = true;
                            is_valid = false;
                        }
                    } else{
                        if (this.form[i].value === '') {
                            this.form[i].error = true;
                            is_valid = false;
                        }
                    }
                }

                if(is_valid){
                    let fd = new FormData();
                    for(let i = 0; i < this.form.length; i++){
                        fd.append(this.form[i].name, this.form[i].value)
                    }
                    fd.append('id', this.props.id)

                    this.$http.put(this.action, fd)
                        .then(response => {
                            store.dispatch('dialog/LoadDialogList').then(() => {
                                store.dispatch('dialog/LoadMessageList', this.$router.currentRoute.query.sel ).then(()=>{
                                    this.modalDialogClose();
                                    this.showMsg( this.renameDialog.msgSuccess )
                                })
                            });
                        }, response => {
                            this.modalDialogClose();
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        });
                }
            },
            Focus(i){
                this.form[i].error = false
            }
        }
    }
</script>

<style lang="sass">
.t-callBack
  width: 320px
  margin: 0 auto
  background: #ffffff
  padding: 24px
  border-radius: 16px
  &__hint
    font-size: 14px
    color: $grey
    margin-top: 8px
  .t-input:after
    bottom: 25px
</style>


// WEBPACK FOOTER //
// src/vue_components/ModalDialog/DialogRename.vue